import React from 'react';
import { useDownloadFile } from '../../../../api/useDownloadFile';
import { PopoverFileLink } from '../../../common/InfoPopover.styles';

/** FOSFA popover body content with file links and value explanations */
export const FosfaPopoverContent: React.FC = () => {
    const { downloadFile } = useDownloadFile();

    const handleDownload = (fileName: string) => (e: React.MouseEvent) => {
        e.preventDefault();
        downloadFile({ category: 'FOSFA', fileName });
    };

    return (
        <>
            <p>Federation of Oils, Seeds and Fats Association</p>
            <PopoverFileLink onClick={handleDownload('FOSFA Heating Instructions.pdf')}>
                FOSFA Heating Instructions
            </PopoverFileLink>
            <PopoverFileLink onClick={handleDownload('FOSFA Operational Procedures.pdf')}>
                FOSFA Operational Procedures
            </PopoverFileLink>
            <PopoverFileLink onClick={handleDownload('FOSFA List Of Acceptable Previous Cargoes.pdf')}>
                FOSFA List Of Acceptable Previous Cargoes
            </PopoverFileLink>
            <PopoverFileLink onClick={handleDownload('FOSFA List Of Banned Immediate Previous Cargoes.pdf')}>
                FOSFA List Of Banned Immediate Previous Cargoes
            </PopoverFileLink>
            <p style={{ marginTop: '0.5rem' }}>The possible values are:</p>
            <ul>
                <li><strong>Acceptable:</strong> product on FOSFA list of acceptable last cargoes.</li>
                <li><strong>Banned:</strong> product on FOSFA list of banned last cargoes.</li>
                <li><strong>Not Listed:</strong> product not on Acceptable or Banned list. Also referred to as NOBL (not on banned list).</li>
                <li><strong>Not Specified:</strong> lack of information.</li>
            </ul>
        </>
    );
};

/** EU popover body content with file links and value explanations */
export const EuPopoverContent: React.FC = () => {
    const { downloadFile } = useDownloadFile();

    const handleDownload = (fileName: string) => (e: React.MouseEvent) => {
        e.preventDefault();
        downloadFile({ category: 'EU', fileName });
    };

    return (
        <>
            <p>European Union commission Directive 96/3 EC</p>
            <PopoverFileLink onClick={handleDownload('EU Commission Directive 96 3 EC.pdf')}>
                EU Commission Directive 96/3 EC
            </PopoverFileLink>
            <p style={{ marginTop: '0.5rem' }}>The possible values are:</p>
            <ul>
                <li><strong>Acceptable:</strong> product on EU directive list of acceptable last cargoes.</li>
                <li><strong>Not Listed:</strong> product not on EU directive list of acceptable last cargoes.</li>
                <li><strong>Not Specified:</strong> lack of information.</li>
            </ul>
        </>
    );
};

/** NIOP popover body content with file links and value explanations */
export const NiopPopoverContent: React.FC = () => {
    const { downloadFile } = useDownloadFile();

    const handleDownload = (fileName: string) => (e: React.MouseEvent) => {
        e.preventDefault();
        downloadFile({ category: 'NIOP', fileName });
    };

    return (
        <>
            <p>National Institute of Oilseed Products</p>
            <PopoverFileLink onClick={handleDownload('NIOP List Of Acceptable Prior Cargo.pdf')}>
                NIOP List Of Acceptable Prior Cargo
            </PopoverFileLink>
            <PopoverFileLink onClick={handleDownload('NIOP Glossary Of Chemical Cargoes.pdf')}>
                NIOP Glossary Of Chemical Cargoes
            </PopoverFileLink>
            <PopoverFileLink onClick={handleDownload('NIOP Trading Rule Chapter 5.pdf')}>
                NIOP Trading Rule Chapter 5
            </PopoverFileLink>
            <p style={{ marginTop: '0.5rem' }}>The possible values are:</p>
            <ul>
                <li><strong>List 1 Acceptable:</strong> product on NIOP list 1 of acceptable last cargoes.</li>
                <li><strong>List 2 Acceptable:</strong> product on NIOP list 2 of acceptable last cargoes.</li>
                <li><strong>Not Listed:</strong> product not on list 1 or list 2.</li>
                <li><strong>Not Specified:</strong> lack of information.</li>
            </ul>
        </>
    );
};
